import { getJobQuote } from "@insite/client-framework/Services/JobQuoteService";
import {
    chain,
    RequestDataFromApi as baseRequestDataFromApi,
} from "@insite/client-framework/Store/Data/JobQuotes/Handlers/LoadJobQuote";
import { createChainHandler, replaceInChain } from "@store/Modules/client-framework/HandlerCreator";

export const RequestDataFromApi = createChainHandler("RequestDataFromApi", chain, async props => {
    try {
        props.apiResult = await getJobQuote(props.apiParameter);
    } catch (error) {
        if ("status" in error && (error.status === 400 || error.status === 404)) {
            props.dispatch({
                type: "Toolkit/Data/JobQuotes/FailedToLoadJobQuote",
                jobQuoteId: props.parameter.jobQuoteId,
                status: 404,
            });
            return false;
        }
        throw error;
    }
});

replaceInChain(chain, baseRequestDataFromApi, RequestDataFromApi);
